import React, { Component } from 'react';
import HomeDashboard from '../components/homeComponents/HomeDashboard';

export default class Home extends Component {
  render() {
    return (
      <div>
        <HomeDashboard />
      </div>
    );
  }
}
